import React from "react";
import { Select } from "@hireart/component-library";
import PropTypes from "prop-types";
import {
  transformTimezonesToSelectOptions,
  ShiftShape,
} from "common/utils/timesheet";
import { TimePicker } from "common-components";
import { CrossDayNotification } from "./sub-components/CrossDayNotification";

export const ShiftTimeSection = ({
  shift,
  shiftDate,
  isReadOnly,
  currentTimezone,
  timezones,
  onStartTimeChange,
  onEndTimeChange,
  onTimezoneChange = undefined,
}) => {
  // Transform raw timezone data into select options
  const timezoneOptions = React.useMemo(() => {
    return transformTimezonesToSelectOptions(timezones);
  }, [timezones]);

  return (
    <div className="flex flex-col gap-6">
      {/* Timezone Selector */}
      <div className="flex flex-col gap-2">
        <Select
          value={currentTimezone || ""}
          label="Timezone"
          isLabelUnstyled
          onChange={(e, value) => onTimezoneChange?.(value)}
          isDisabled={isReadOnly}
          options={timezoneOptions}
          placeholder="Select timezone..."
          className="w-full"
          size="md"
        />
      </div>

      {/* Start Time */}
      <TimePicker
        value={shift.startTime}
        onChange={onStartTimeChange}
        isDisabled={isReadOnly}
        label="Start"
        timezone={currentTimezone}
      />

      <div className="mt-2 flex w-full flex-row items-center justify-center gap-2">
        <div className="h-4 w-4 text-neutral-60">→</div>
      </div>

      {/* End Time */}
      <TimePicker
        value={shift.endTime}
        onChange={onEndTimeChange}
        isDisabled={isReadOnly}
        label="End"
        timezone={currentTimezone}
      />

      {/* Cross-day shift notification */}
      <CrossDayNotification shift={shift} shiftDate={shiftDate} />
    </div>
  );
};

ShiftTimeSection.propTypes = {
  shift: ShiftShape.isRequired,
  shiftDate: PropTypes.instanceOf(Date).isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  currentTimezone: PropTypes.string.isRequired,
  timezones: PropTypes.arrayOf(
    PropTypes.shape({
      tzname: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
      utc_offset: PropTypes.string.isRequired,
    })
  ).isRequired,
  onStartTimeChange: PropTypes.func.isRequired,
  onEndTimeChange: PropTypes.func.isRequired,
  onTimezoneChange: PropTypes.func,
};
